import { render, staticRenderFns } from "./AccommodationCategories.vue?vue&type=template&id=8920eb8e&"
import script from "./AccommodationCategories.vue?vue&type=script&lang=js&"
export * from "./AccommodationCategories.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "AccommodationCategories.vue"
export default component.exports